(function(){
var V={"mag_blue": 52802057437493, "mag_mixb": 67601302847797, "mag_rasp": 67601302880565, "mag_rlem": 67601302913333, "mag_citrus": 67601302946101},MAG=52802057371957,ELEC=52802057240885;
function items(o){var m={};function add(id,q){if(id)m[id]=(m[id]||0)+q}
 (o.lines||[]).forEach(function(l){var x=l.x||{},q=x.q||1;
  if(x.kind==='cre')add(V[x.fl],q);
  else if(x.kind==='pack')(x.fls||[]).forEach(function(f){add(V[f],q)});
  else if(x.kind==='mix')(x.fls||[]).forEach(function(f){add(V[f],q)});
  else if(x.kind==='bundle')(x.items||[]).forEach(function(k){add(k==='cre'?V[x.fl]:k==='mag'?MAG:ELEC,q)});
  else if(x.k==='mag'||x.id==='mag'||x.id==='magOffer')add(MAG,q);
  else if(x.k==='elec'||x.id==='elec')add(ELEC,q);});
 return Object.keys(m).map(function(k){return {id:+k,quantity:m[k]}})}
if(window.DV)DV._renderTY=function(o){var its=items(o);if(!its.length)return;
 document.documentElement.classList.add('dv-going');
 fetch('/cart/clear.js',{method:'POST'}).then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:its})})})
 .then(function(r){if(!r.ok)throw new Error(r.status);location.href='/checkout'})
 .catch(function(e){document.documentElement.classList.remove('dv-going');console.error('[DV] cart error',e)})};
})();